
import { PartnerCard } from "./PartnerCard";
import { Partner } from "@/hooks/usePartnersManager";

interface PartnersListProps {
  partners: Partner[];
  onEdit: (partner: Partner) => void;
  onDelete: (partnerId: string) => void;
  saving: boolean;
  hasFilters: boolean;
}

export const PartnersList = ({ partners, onEdit, onDelete, saving, hasFilters }: PartnersListProps) => {
  if (partners.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        {hasFilters 
          ? "No partners match your search criteria." 
          : "No partners found. Click 'Add Partner' to create your first partner."
        }
      </div>
    );
  }

  return (
    <div className="grid gap-4">
      {partners.map((partner) => (
        <PartnerCard
          key={partner.id}
          partner={partner}
          onEdit={onEdit}
          onDelete={onDelete}
          saving={saving}
        />
      ))}
    </div>
  );
};
